import styled from "styled-components";

const LoaderPageStyle = styled.div`
background: #111823;
height:100vh;
width:100vw;
display:flex;
align-items:center;
justify-content:center;
.loadingPage{
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
}
h1{
    color:white;
    margin-bottom:20px
    font-size: 22px;
}
.platform-error {
    color: #ff4d4f;
    font-size: 15px;
    line-height: 1.5;
    max-width: 420px;
    margin: 0 24px 8px;
    text-align: center;
}
.loadingCircle{
    width: 85px;
    height: 85px;
    border: 5px solid #007AFF;
    border-radius: 90px;
    border-left: 5px solid transparent;
    animation: refreshRound 1s infinite;
  }
  @keyframes refreshRound {
    0%{
      transform: rotate(0deg);
    }
    0%{
      transform: rotate(359deg);
    }
  }
`

const ExpirePageStyle = styled.div`
  background-image: url("./static/Rectangle3.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;

  .expire-card {
    background: linear-gradient(145deg, #131313, #0d0d0d);
    max-width: 440px;
    width: 100%;
    padding: 40px 36px;
    text-align: center;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
  }

  .icon-wrap {
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 56px;
      height: 56px;
    }
  }

  .icon-wrap.expired {
    svg path {
      fill: #007aff;
    }
  }

  .icon-wrap.failed {
    svg path {
      fill: #ff3b3b;
    }
  }

  .expire-title {
    font-size: 22px;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 10px;
    line-height: 1.3;
  }

  .expire-desc {
    color: #8e9aaa;
    font-size: 14px;
    line-height: 1.6;
    margin: 0 0 24px;
  }

  .retry-msg {
    font-size: 13px;
    font-weight: 600;
    margin: 0 0 16px;
    padding: 10px 14px;
    border-radius: 10px;
    line-height: 1.4;
  }

  .retry-msg.success {
    color: #34c759;
    background: rgba(52, 199, 89, 0.1);
    border: 1px solid rgba(52, 199, 89, 0.25);
  }

  .retry-msg.error {
    color: #ff3b3b;
    background: rgba(255, 59, 48, 0.1);
    border: 1px solid rgba(255, 59, 48, 0.25);
  }

  .btn-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .btn-primary {
    padding: 14px 20px;
    border-radius: 12px;
    border: none;
    background: #007aff;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    width: 100%;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.1s ease;

    &:hover:not(:disabled) {
      background: #0066d6;
    }
    &:active:not(:disabled) {
      transform: scale(0.98);
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn-secondary {
    padding: 13px 20px;
    border-radius: 12px;
    border: 1.5px solid rgba(0, 122, 255, 0.5);
    background: rgba(0, 122, 255, 0.08);
    color: #3d9bff;
    font-size: 15px;
    font-weight: 600;
    width: 100%;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease, transform 0.1s ease;

    &:hover {
      border-color: #007aff;
      background: rgba(0, 122, 255, 0.15);
    }
    &:active {
      transform: scale(0.98);
    }
  }

  .btn-tertiary {
    padding: 12px 20px;
    border-radius: 12px;
    border: 1.5px solid rgba(255, 255, 255, 0.1);
    background: transparent;
    color: #8e9aaa;
    font-size: 14px;
    font-weight: 600;
    width: 100%;
    cursor: pointer;
    transition: border-color 0.2s ease, color 0.2s ease, transform 0.1s ease;

    &:hover {
      border-color: rgba(255, 255, 255, 0.2);
      color: #b0bfd0;
    }
    &:active {
      transform: scale(0.98);
    }
  }

  .btn-logout {
    padding: 10px 20px;
    border: none;
    background: transparent;
    color: #5a6a7a;
    font-size: 13px;
    font-weight: 500;
    width: 100%;
    cursor: pointer;
    margin-top: 4px;
    transition: color 0.2s ease;

    &:hover {
      color: #8e9aaa;
    }
  }
`

export { LoaderPageStyle, ExpirePageStyle };
